export function AppAds() {
    return (
        <p>
            google.com, pub-5424632104835822, DIRECT, f08c47fec0942fa0
        </p>
    );
}